import { React, _ } from '../../lib';
import { reactFlyout } from '../component-react';
import { FormButton, FormButtonSet } from './buttons';
import { Checkbox } from './checkbox';
export const PromptConfirm = (props) => {
    reactFlyout(props.title ?? 'Are you sure?', props.size ?? [320, 240], React.createElement(ConfirmUI, { ...props }));
};
const ConfirmUI = (props) => {
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState('');
    return (React.createElement("div", { className: "tailwind-wrapper" },
        React.createElement("div", { className: "leading-normal my-2" }, props.msg),
        React.createElement(FormButtonSet, { loading: loading, msg: message },
            React.createElement(FormButton, { lbl: "Yes", type: "submit", autoFocus: true, onClick: () => {
                    setLoading(true);
                    setMessage('');
                    props.yes(result => {
                        setLoading(false);
                        if (_.isString(result)) {
                            setMessage(result);
                            return;
                        }
                        props.flyout?.Close();
                        return;
                    });
                } }),
            React.createElement(FormButton, { lbl: "Cancel", onClick: () => {
                    props.no?.();
                    props.flyout?.Close();
                } }))));
};
export const PromptConfirmWithCheckbox = (props) => {
    reactFlyout(props.title ?? 'Are you sure?', props.size ?? [320, 240], React.createElement(ConfirmUIWithCheckbox, { ...props }));
};
const ConfirmUIWithCheckbox = (props) => {
    const [isChecked, setIsChecked] = React.useState(props.defaultChecked);
    const [loading, setLoading] = React.useState(false);
    const [message, setMessage] = React.useState('');
    return (React.createElement("div", { className: "tailwind-wrapper" },
        React.createElement("div", { className: "leading-normal my-2" },
            props.msg,
            React.createElement("div", { className: "py-2" },
                React.createElement(Checkbox, { lbl: props.question, value: isChecked, onUpdate: v => {
                        setIsChecked(v);
                    } }))),
        React.createElement(FormButtonSet, { loading: loading, msg: message },
            React.createElement(FormButton, { lbl: "Yes", type: "submit", autoFocus: true, onClick: () => {
                    setLoading(true);
                    setMessage('');
                    props.yes(isChecked, result => {
                        setLoading(false);
                        if (_.isString(result)) {
                            setMessage(result);
                            return;
                        }
                        props.flyout?.Close();
                        return;
                    });
                } }),
            React.createElement(FormButton, { lbl: "Cancel", onClick: () => {
                    props.no?.();
                    props.flyout?.Close();
                } }))));
};
//# sourceMappingURL=confirm.js.map